import { useCallback, useSyncExternalStore } from 'react';
import { getFavorites, subscribe, type FavoriteImage } from './favoriteImagesStore';

/**
 * React binding for the favorite-images store. Re-renders the consumer whenever
 * favorites change (in this tab).
 */
export function useFavoriteImages(): FavoriteImage[] {
  const getSnapshot = useCallback(() => getFavorites(), []);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
